export default __webpack_public_path__ + "static/media/b_c.fd3cb129.png";